import { isEmpty, isString } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  getPublicTemplates,
  getPublicTemplatesWithDifferentRootAPI,
} from 'redux/publicTemplates/actionCreators'
import I18n from 'translations/i18n'

import { Drawer, Flex, Spacer, Text } from '@jisr-hr/design-system'
import { Button, Icon } from '@jisr-hr/ds'
// import { ReactComponent as FilterIcon } from '@jisr-hr/design-system/dist/assets/icons/Filter.svg'
import { ReactComponent as ArrowIcon } from '@jisr-hr/design-system/dist/assets/icons/down-arrow.svg'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { departmentsLoad } from 'redux/actions/filterActions'
import { useFilters } from './components/context'
import { filterComponent, getPublicFilterKeys, newState } from './helper'
import styles from './styles.module.css'

const Filter = ({
  filters,
  onSubmitFilter,
  backTitle,
  onClearFilters,
  saveParams,
  btnText = I18n.t('filters'),
  // onExemptedEmployeesSubmit,
  selected,
  noAttendanceComp,
  publicTemplateRootApi,
  size = 'sm',
  selectedCR,
  isClearable = true,
  platform,
}) => {
  const subscribed_features = useSelector(
    (s) => s.auth?.company?.subscribed_features || [],
    shallowEqual,
  )
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const filterSelected = useSelector((s) => s.filters.filters)
  const [open, setOpen] = React.useState(false)

  const { filter = {}, setFilter } = useFilters()

  const getFiltersList = () => {
    if (!filters.includes('statuses')) delete filter.statuses
    if (!filters.includes('status')) delete filter.status
    return filter
  }

  const submitFilter = () => {
    if (onSubmitFilter) {
      onSubmitFilter(getFiltersList())
    }
    setOpen(false)
  }

  // const onExemptedEmployeesOnChange = (val) => {
  //   onExemptedEmployeesSubmit(val);
  // };

  const clearFilters = () => {
    setFilter(newState)
    if (onClearFilters) {
      onClearFilters(newState)
    } else {
      submitFilter()
    }
    setOpen(false)
  }

  React.useEffect(() => {
    if (saveParams) {
      setFilter({
        ...newState,
        area_id:
          filterSelected?.area_id?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        area_ids:
          filterSelected?.areas?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        department_id:
          filterSelected?.department_id?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        department_ids:
          filterSelected?.departments?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        job_title_id:
          filterSelected?.job_title_id?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        job_title_ids:
          filterSelected?.job_titles?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        grade_id:
          filterSelected?.grade_id?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        grade_ids:
          filterSelected?.grades?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        business_unit_id:
          filterSelected?.business_unit_id?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        business_unit_ids:
          filterSelected?.business_unit_ids?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        location_id:
          filterSelected?.location_id?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        location_ids:
          filterSelected?.location_ids?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        record_location_ids:
          filterSelected?.record_location_ids?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        nationality:
          filterSelected?.nationality?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        job_openings:
          filterSelected?.job_openings?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        nationalities:
          filterSelected?.nationalities?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        shift_type:
          filterSelected?.shift_type?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        shift_types:
          filterSelected?.shift_types?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        shift_ids:
          filterSelected?.shift_ids?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        employment_type_id:
          filterSelected?.employment_type_id?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        employment_type_ids:
          filterSelected?.employment_type_ids?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        reporting_method_ids:
          filterSelected?.reporting_method_ids?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        biometric_ids:
          filterSelected?.biometric_ids?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        statuses:
          filterSelected?.statuses?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        status_employee:
          filterSelected?.status_employee?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        outsourcing_company_ids:
          filterSelected?.outsourcing_company_ids?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        payment_methods:
          filterSelected?.payment_methods?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        mol_registration_ids:
          filterSelected?.mol_registrations?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        gosi_subscriptions:
          filterSelected?.gosi_subscriptions?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        is_gosi_linked:
          filterSelected?.gosi_linked_data?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        is_data_correct:
          filterSelected?.uncorrect_data?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        payment_details:
          filterSelected?.uncorrect_data?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        document_type:
          filterSelected?.document_type?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        request_type:
          filterSelected?.request_type?.record?.map((i) => (typeof i === 'object' ? i.id : i)) ||
          [],
        ats_job_opening_statuses:
          filterSelected?.ats_job_opening_statuses?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        request_statuses:
          filterSelected?.request_statuses?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        pending_on:
          filterSelected?.pending_on?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        category:
          filterSelected?.category?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        commercial_registration:
          filterSelected?.commercial_registration?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        external_nationalities:
          filterSelected?.external_nationalities?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        id_type:
          filterSelected?.id_type?.record?.map((i) => (typeof i === 'object' ? i.id : i)) || [],
        insurance_policy_class:
          filterSelected?.insurance_policy_class?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        insurance_status:
          filterSelected?.insurance_status?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],
        is_member_linked:
          filterSelected?.member_linked_data?.record?.map((i) =>
            typeof i === 'object' ? i.id : i,
          ) || [],

        // ###---### Filters in initial Filter state Not in filters ----------------------
        // loan_type_ids
        // expiry_status
        // extra_cols
        // additional_columns
        // additional_info
        // categories
        // payroll_transaction_type_ids
        // status: [1],
        // task_statuses
        // requests_approvers_list_ids
        // record_types
        // record_loc_ids
        // payrunTypes
        // payrun_types
        // request_status_ids
        // request_type_ids
        // leave_status_ids
        // leave_type_ids
      })
    }
  }, [
    filterSelected?.area_id?.record?.length,
    filterSelected?.areas?.record?.length,
    filterSelected?.department_id?.record?.length,
    filterSelected?.departments?.record?.length,
    filterSelected?.job_title_id?.record?.length,
    filterSelected?.job_titles?.record?.length,
    filterSelected?.grade_id?.record?.length,
    filterSelected?.grades?.record?.length,
    filterSelected?.business_unit_id?.record?.length,
    filterSelected?.business_unit_ids?.record?.length,
    filterSelected?.location_id?.record?.length,
    filterSelected?.location_ids?.record?.length,
    filterSelected?.record_location_ids?.record?.length,
    filterSelected?.nationality?.record?.length,
    filterSelected?.nationalities?.record?.length,
    filterSelected?.shift_type?.record?.length,
    filterSelected?.shift_types?.record?.length,
    filterSelected?.shift_ids?.record?.length,
    filterSelected?.employment_type_id?.record?.length,
    filterSelected?.employment_type_ids?.record?.length,
    filterSelected?.job_openings?.record?.length,
    filterSelected?.reporting_method_ids?.record?.length,
    filterSelected?.biometric_ids?.record?.length,
    filterSelected?.statuses?.record?.length,
    filterSelected?.status_employee?.record?.length,
    filterSelected?.outsourcing_company_ids?.record?.length,
    filterSelected?.payment_methods?.record?.length,
    filterSelected?.mol_registrations?.record?.length,
    filterSelected?.gosi_subscriptions?.record?.length,
    filterSelected?.uncorrect_data?.record?.length,
    filterSelected?.document_type?.record?.length,
    filterSelected?.request_type?.record?.length,
    filterSelected?.ats_job_opening_statuses?.record?.length,
    filterSelected?.request_statuses?.record?.length,
    filterSelected?.pending_on?.record?.length,
    filterSelected?.category?.record?.length,
    filterSelected?.commercial_registration?.record?.length,
    filterSelected?.external_nationalities?.record?.length,
    filterSelected?.id_type?.record?.length,
    filterSelected?.insurance_policy_class?.record?.length,
    filterSelected?.insurance_status?.record?.length,
  ])

  useEffect(() => {
    if (!isEmpty(selected)) {
      let shift_type = selected?.shift_type
      if (isString(selected?.shift_type)) {
        shift_type = selected?.shift_type ? [selected.shift_type] : []
      }
      const defaultSelectedFilters = {
        ...filter,
        ...selected,
        shift_type,
      }
      setFilter(defaultSelectedFilters)
    }
  }, [selected])

  useEffect(() => {
    const isSupportCustomRequests = subscribed_features?.includes('custom_requests')
    if (!isEmpty(filters)) {
      const fltred = filters.filter(
        (f) =>
          f !== 'request_type' &&
          f !== 'tasks_request_type' &&
          f !== 'ats_job_opening_statuses' &&
          f !== 'insurance_status',
      )
      let type = filters.includes('tasks_request_type') ? 'task_type' : 'request_type'
      if (filters.includes('ats_job_opening_statuses') || filters.includes('job_openings')) {
        type = ''
      }
      const newFltr = [...fltred, isSupportCustomRequests && type].filter(Boolean)
      if (publicTemplateRootApi) {
        dispatch(
          getPublicTemplatesWithDifferentRootAPI(
            {
              filters: getPublicFilterKeys(newFltr),
            },
            publicTemplateRootApi,
          ),
        )
      } else {
        const filterKeys = getPublicFilterKeys(newFltr)

        dispatch(
          getPublicTemplates({
            filters: filterKeys,
            platform: filterKeys.lookups ? platform : undefined,
          }),
        )
      }
    }
  }, [subscribed_features])

  useEffect(() => {
    if (pathname.includes('reports')) {
      dispatch(departmentsLoad({ template: 'public' }))
    }
  }, [])

  return (
    <div>
      <Button
        data-testid="filters-drawer"
        size={size}
        variant="secondary"
        type="button"
        onClick={() => {
          setOpen(true)
        }}
      >
        <Icon name="filter-lines" />
        {btnText}
      </Button>
      <Drawer
        active={open}
        onClose={() => setOpen(false)}
        title={I18n.t('filter')}
        content={
          <>
            {backTitle && (
              <Flex
                itemsCenter
                className={styles.backIcon}
                onClick={() => setOpen(false)}
              >
                <ArrowIcon />
                <Spacer width={8} />
                <Text typography="paragraph16">{I18n.t(backTitle)}</Text>
              </Flex>
            )}
            {filters?.map((fltr) => {
              const { component: Component, ...rest } =
                filterComponent.find((i) => i.title === fltr || i.extra_title === fltr) || {}
              if (Component) {
                if (
                  (filters.includes('status_employee') || filters.includes('statuses')) &&
                  ['statuses', 'status_employee'].includes(fltr)
                ) {
                  return (
                    <Component
                      {...rest}
                      data-testid={fltr}
                      key={fltr}
                      filterKey={fltr}
                      filters={filters}
                      statusOnly={
                        filters.includes('statuses') && !filters.includes('status_employee')
                      }
                      emplyeeStatusOnly={
                        !filters.includes('statuses') && filters.includes('status_employee')
                      }
                    />
                  )
                }
                return (
                  <Component
                    {...rest}
                    crId={selectedCR}
                    key={fltr}
                    filters={filters}
                  />
                )
              }
              return undefined
            })}
            {/* <ViewedComponent
              available={!!onExemptedEmployeesSubmit}
              alt={noAttendanceComp}
            >
              <ExemptedEmployeesToggle onSubmit={onExemptedEmployeesOnChange} />
            </ViewedComponent> */}
            {noAttendanceComp}
          </>
        }
        footer={
          <Flex>
            <Button
              label={I18n.t('apply')}
              onClick={submitFilter}
              size="md"
              data-testid="apply_filters"
            />
            <Spacer width={8} />
            {isClearable && (
              <Button
                label={I18n.t('clear_all_filters')}
                onClick={() => {
                  clearFilters()
                }}
                size="md"
                variant="secondary"
                data-testid="clear_filters"
              />
            )}
          </Flex>
        }
      />
    </div>
  )
}

Filter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.string),
  onSubmitFilter: PropTypes.func,
  backTitle: PropTypes.string,
  onClearFilters: PropTypes.func,
  saveParams: PropTypes.bool,
  eventName: PropTypes.string,
  size: PropTypes.string,
  btnText: PropTypes.string,
  triggerIconOnly: PropTypes.bool,
  withoutAppliedFilters: PropTypes.bool,
  noAttendanceComp: PropTypes.node,
  icon: PropTypes.node,
  selected: PropTypes.shape(),
}

export default Filter
